// extracted by mini-css-extract-plugin
module.exports = {"container":"e_wB","question":"e_xB","button":"e_yB","buttonNegative":"e_zB","buttonPositive":"e_AB","icon":"e_BB","iconNegative":"e_CB","iconPositive":"e_DB"};